import { type PropsWithChildren } from 'react';

export const ClientOnly = ({ children }: PropsWithChildren) => {
  // not implemented yet but having the stub allows us to future proof
  return <>{children}</>;
};
